import { render, staticRenderFns } from "./UMLClassRelation.vue?vue&type=template&id=bd6f0fca&scoped=true&"
import script from "./UMLClassRelation.vue?vue&type=script&lang=js&"
export * from "./UMLClassRelation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd6f0fca",
  null
  
)

export default component.exports